module.exports = ($scope, $uibModalInstance, message) ->

  $scope.message = message

  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"

  $scope.save = ->
    $uibModalInstance.close()
